if (!customElements.get('cph-customer-reviews')) {
  customElements.define('cph-customer-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.messages = JSON.parse(this.querySelector('.cph-review-messages').textContent);
      this.querySelectorAll('[data-load-reviews]').forEach(button => button.addEventListener('click', () => this.load(button)));
    }
    node(tag, className, value) {
      const node = document.createElement(tag); node.className = className;
      if (value !== undefined) node.textContent = value;
      return node;
    }
    card(review, earlier) {
      const card = this.node('article', 'cph-customer-review'); card.id = `customer-review-${review.id}`;
      const meta = this.node('div', 'cph-customer-review__meta');
      const stars = this.node('span', 'cph-customer-review__stars', '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating));
      stars.setAttribute('aria-label', this.messages.stars.replace('__COUNT__', review.rating));
      const date = this.node('time', '', new Date(review.created_at).toLocaleDateString(this.dataset.locale)); date.dateTime = review.created_at;
      meta.append(stars, date); card.append(meta);
      if (earlier) card.append(this.node('p', 'cph-review-help', `${this.messages.vintage} ${review.vintage}`));
      if (review.body) { const body = this.node('p', 'cph-customer-review__body', review.body); body.lang = review.locale; card.append(body); }
      card.append(this.node('p', 'cph-customer-review__author', review.author));
      if (review.verified_purchase === true) card.append(this.node('span', 'cph-customer-review__verified', this.messages.verified));
      return card;
    }
    async load(button) {
      if (button.disabled) return;
      button.disabled = true;
      const status = this.querySelector('.cph-review-list-status'); status.textContent = '';
      const kind = button.dataset.loadReviews;
      try {
        const url = `${this.dataset.api.replace(/\/$/, '')}/api/public/customer-reviews/products/${this.dataset.product}?earlier=${kind === 'earlier'}&offset=${button.dataset.offset}`;
        const response = await fetch(url, { credentials: 'omit' });
        if (!response.ok) throw new Error();
        const data = await response.json();
        const list = this.querySelector(`[data-review-list="${kind}"]`);
        const cards = data.reviews.map(review => this.card(review, kind === 'earlier'));
        list.append(...cards);
        button.dataset.offset = String(Number(button.dataset.offset) + cards.length);
        button.hidden = !data.has_more;
        if (cards.length) { cards[0].tabIndex = -1; cards[0].focus(); }
      } catch { status.textContent = this.messages.error; }
      finally { button.disabled = false; }
    }
  });
}
